// primary = KT BLUE
// seconadry = KT GREEN
export default {
  errors: { main: '#C91E2F', dark: '#6F111A' },
  warnings: { main: '#FFA62A', dark: '#D77C35' },
  primary: { main: '#2998cf', dark: '#297AB0' },
  secondary: { main: '#87B63E', dark: '#60812C' },
  success: { main: '#87B63E', dark: '#60812C' }, // same as secondary for now is this correct?
  blue: { main: '#29ABE2', dark: '#29ABE2', link: '#29ABE2' },
};
